import React, { useEffect, useState } from 'react'
import { compareAsc, compareDesc } from 'date-fns'

import Header from './Header'
import VideoItem from './VideoItem'
import FAB from '../FAB/FAB'

import './styles/video-listing.scss'

const VideoListing = props => {
  const { videos, setVideos } = props

  const [visibleCount, setVisibleCount] = useState(15)
  const [isMoreBtnVisible, setIsMoreBtnVisible] = useState(true)

  useEffect(() => {
    setIsMoreBtnVisible(prevState => {
      return videos.length > 0 && visibleCount < videos.length
    })
  }, [videos, visibleCount])

  const orderByNewest = arr => {
    const newArr = [...arr]

    newArr.sort((a, b) => {
      const leftDate = new Date(a.snippet.publishedAt)
      const rightDate = new Date(b.snippet.publishedAt)

      return compareDesc(leftDate, rightDate)
    })

    setVideos(newArr)
  }

  const orderByOldest = arr => {
    const newArr = [...arr]

    newArr.sort((a, b) => {
      const leftDate = new Date(a.snippet.publishedAt)
      const rightDate = new Date(b.snippet.publishedAt)

      return compareAsc(leftDate, rightDate)
    })

    setVideos(newArr)
  }

  const orderByName = arr => {
    const newArr = [...arr]

    newArr.sort((a, b) => {
      const firstLetterA = a.snippet.title
        .match(/[a-zA-Z]+/)
        .toString()
        .toLowerCase()
      const firstLetterB = b.snippet.title
        .match(/[a-zA-Z]+/)
        .toString()
        .toLowerCase()

      return firstLetterA.localeCompare(firstLetterB)
      //return a.snippet.title.charCodeAt(0) - b.snippet.title.charCodeAt(0)
    })

    setVideos(newArr)
  }

  return (
    <section className="video-listing">
      <Header
        videos={videos}
        orderByName={orderByName}
        orderByOldest={orderByOldest}
        orderByNewest={orderByNewest}
      />
      <ul className="video-grid" id="video-listing">
        {videos.map((video, index) => {
          const {
            snippet: {
              resourceId: { videoId },
              publishedAt,
              title,
              thumbnails,
              channelTitle,
            },
          } = video

          if (index >= visibleCount) return

          return (
            <li key={videoId} className="video-grid__item video-listing-item">
              <VideoItem
                id={videoId}
                publishedAt={publishedAt}
                title={title}
                thumbnails={thumbnails}
                channelTitle={channelTitle}/>
            </li>
          )
        })}
      </ul>
      {isMoreBtnVisible && (
        <FAB setVisibleVideo={setVisibleCount}/>
      )}
    </section>
  )
}

export default VideoListing